import { MetadataAnswersType, ExperimentAllocation } from '../../api';
import { logger } from '../../utils/logger';
import { PostAndPollAdditionalDataParams, usePostAndPollAdditionalData } from './usePostAndPollAdditionalData';

export const GET_QUERY_STRING_TIMEOUT_MS = 20 * 1000;

export interface SearchParametersData {
    searchQuery?: string;
    metadata?: MetadataAnswersType;
    summary?: string;
    experimentAllocation?: ExperimentAllocation;
}

export const useGetSearchParametersData = () => {
    const { isLoading, postAndPollAdditionalData } = usePostAndPollAdditionalData();

    const getSearchParametersData = async ({
        leafClassification,
        userInput,
        contextId,
        abortController,
        metadata,
        tierData,
    }: Pick<
        PostAndPollAdditionalDataParams,
        'metadata' | 'contextId' | 'leafClassification' | 'userInput' | 'abortController' | 'tierData'
    >): Promise<SearchParametersData | undefined> => {
        if (!leafClassification) {
            return;
        }
        try {
            const result = await postAndPollAdditionalData({
                requestType: 'get_query_string',
                leafClassification,
                userInput,
                contextId,
                extractors: ['QUERY'],
                tierData,
                abortController,
                metadata,
                postRetries: 0,
                pollTimeout: GET_QUERY_STRING_TIMEOUT_MS,
                flowRetries: 0,
            });

            const { experiment_allocation, resolved_data } = result || {};

            return {
                searchQuery: resolved_data?.query_string,
                metadata: resolved_data?.metadata
                    ? {
                          service_options: resolved_data?.metadata.filters,
                      }
                    : undefined,
                summary: resolved_data?.summary,
                experimentAllocation: experiment_allocation,
            };
        } catch (error: any) {
            logger.warn(`continue creating brief after search extraction failure: ${error.message}`);
            return {};
        }
    };

    return {
        getSearchParametersData,
        isLoading,
    };
};
